import { Grid, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import { usePushBreadcrumb } from "~/utils/usePushBreadcrumb";


const pageMark = { label: 'Encryption Settings' }

const DatabaseClassificationProtectionSettings: FC = () => {
  usePushBreadcrumb(pageMark, { toMatch: '/settings/encryption/'})

  return (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <Card>
          <CardActionArea {...actionTo("/settings/encryption/classification-rules")}>
            <CardContent>
              <Typography variant="subtitle1">Data Classification Rules</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card>
          <CardActionArea {...actionTo("/settings/encryption/data-protection-rules")}>
            <CardContent>
              <Typography variant="subtitle1">Data Protection Rules</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card>
          <CardActionArea {...actionTo("/settings/encryption/info-types")}>
            <CardContent>
              <Typography variant="subtitle1">Data Info Types</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    </Grid>
  )
}

export default DatabaseClassificationProtectionSettings;

const actionTo = (to:string) => ({
  LinkComponent: RouterLink,
  to,
  href: to,
})
